import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { money } from "@/components/billing/RateTable";
import { MoveCycleForm, completedLabel } from "@/components/billing/MoveCycleForm";

export const NotInCycle = ({ lines, highlight, onChanged, onError }) => {
  const [openId, setOpenId] = useState(null);
  if (!lines?.length) return null;
  return (
    <section className="compliance-card billing-uncycled" data-testid="billing-not-in-cycle">
      <div className="section-heading">
        <div>
          <h3><AlertTriangle size={16} /> Not in a billing cycle</h3>
          <p>{lines.length} ready-to-bill evaluation(s) have no cycle month, so they would be skipped. Assign each one to the cycle of its completed-on date.</p>
        </div>
      </div>
      <div className="credential-table-wrap">
        <table>
          <thead><tr><th>Client</th><th>Student</th><th>Type</th><th>Provider</th><th>Completed</th><th>Client fee</th><th /></tr></thead>
          <tbody>
            {lines.map((line) => {
              const { day, basis } = completedLabel(line);
              const suggested = line.completed_on ? line.completed_on.slice(0, 7) : "";
              return (
                <tr key={line.evaluation_id} className={highlight === line.evaluation_id ? "is-highlighted" : ""} data-testid={`uncycled-line-${line.evaluation_id}`}>
                  <td>{line.client_name}</td>
                  <td>{line.student_initials}</td>
                  <td>{line.evaluation_type}</td>
                  <td>{line.provider_name || "—"}</td>
                  <td>{day}{basis ? <small className="fee-source"> · {basis}</small> : null}</td>
                  <td>{line.billing.client_fee === null || line.billing.client_fee === undefined ? "—" : money(line.billing.client_fee)}</td>
                  <td className="credential-actions">
                    {openId === line.evaluation_id
                      ? <MoveCycleForm line={line} defaultMonth={suggested} label="Assign" onDone={(message) => { setOpenId(null); onChanged(message); }} onError={onError} onCancel={() => setOpenId(null)} />
                      : <button type="button" className="button button-secondary" data-testid={`assign-cycle-${line.evaluation_id}`} onClick={() => setOpenId(line.evaluation_id)}>Assign to cycle</button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};
